import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ChatService } from "../../../@core/api/chat.service";
import { CampaignProjectService } from "../../../@core/api/campaign-project.service";
import { Chat } from "../../../@core/data/chat";
import { Campaign } from "../../../@core/data/campaign";
import { ChatFieldComponent } from "../chat-field/chat-field.component";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-chat-new",
  templateUrl: "./chat-new.component.html",
  styleUrls: ["./chat-new.component.scss"],
})
export class ChatNewComponent implements OnInit {
  id: string;
  loading: boolean = false;
  editing: boolean = false;
  chat: Chat = {
    name: "",
    uid: "",
    id: "",
    settings: {},
    messages: [],
    privacies: [],
  };
  campaigns: Campaign[] = [];
  blocking = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private chatService: ChatService,
    private campaignService: CampaignProjectService
  ) {}

  async ngOnInit() {
    let id = this.route.snapshot.params["id"];

    if (id) {
      this.loading = true;
      this.editing = true;
      this.id = id;
      this.chat = <Chat>await this.chatService.getChat(id);
    }

    this.campaigns = <any>(
      await this.campaignService.getCampaigns(
        { pageNumber: 0, perPage: 1000 },
        {},
        {}
      )
    );

    this.loading = false;

    if (!this.chat.notAllowed) {
      this.chat.notAllowed = {};
    }

    Object.keys(this.chat.notAllowed).map((k) => {
      this.blocking.push({
        id: k,
        values: this.chat.notAllowed[k].values,
        title: this.chat.notAllowed[k].title,
      });
    });
  }

  addField() {
    this.chat.messages.push({ type:"message"});
  }

  removeField(i) {
    this.chat.messages.splice(i, 1);
  }

  addFieldPrivacy() {
    this.chat.privacies.push({
      inputType: "check",
      validation: {
        exists: true,
      },
    });
  }

  removeFieldPrivacy(i) {
    this.chat.privacies.splice(i, 1);
  }

  addBlockField(i) {
    this.blocking.push({
      id: "",
      values: "",
      title: "",
    });
  }

  removeBlockField(i) {
    this.blocking.splice(i, 1);
  }

  async updateField(data, index) {
    this.chat.messages[index] = data;
  }

  async updateFieldPrivacy(data, index) {
    this.chat.privacies[index] = data;
  }

  move(direction, index) {
    switch (direction) {
      case "down":
        if (index < this.chat.messages.length - 1) {
          let moving = this.chat.messages[index];
          this.chat.messages[index] = this.chat.messages[index + 1];
          this.chat.messages[index + 1] = moving;
        }
        break;
      case "up":
        if (index > 0) {
          let moving = this.chat.messages[index];
          this.chat.messages[index] = this.chat.messages[index - 1];
          this.chat.messages[index - 1] = moving;
        }
        break;

      default:
        break;
    }
  }

  async save() {
    this.chat.notAllowed = this.blocking;
    if (this.id) {
      console.log(this.chat);

      try {
        await this.chatService.editChat(this.chat, this.id);
        this.router.navigate(["home", "chats"]);
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        let data = <any>await this.chatService.createChat(this.chat);
        this.id = data.id;
        this.router.navigate(["home", "chats"]);
      } catch (e) {
        console.error(e);
      }
    }
  }
}
